import React,{useEffect,useState} from "react";
import { useParams } from "react-router-dom";
import Master from "./Master";

function Newsdetail(){


    const { id } = useParams();
  const [news, setNews] = useState(null);


  useEffect(() => {
    fetch(`https://drpatangecitydentalclinic.com/api/news.php?id=${id}`)
      .then((res) => res.json())
      .then((data) => setNews(data));
  }, [id]);

  if (!news) return <h2>Loading...</h2>;


    return(
        <Master>
                {/* Page Header Start */}
	<div className="page-header">
		<div className="container">
			<div className="row">
				<div className="col-lg-12">
					{/* Page Header Box Start */}
					<div className="page-header-box">
						<h1 className="text-anime-style-2" data-cursor="-opaque">{news.headline}</h1>
						<div className="post-single-meta wow fadeInUp">
							<ol className="breadcrumb">
                                <li className="breadcrumb-item"><i className="fa-regular fa-user"></i> admin</li>
								<li className="breadcrumb-item"><i className="fa-regular fa-clock"></i>{news.news_date}</li>
                            </ol>
						</div>		
					</div>
					{/* Page Header Box End */}
				</div>
			</div>
		</div>
	</div>
	{/* Page Header End */}

    {/* Page Single Post Start */}
	<div className="page-single-post">
        <div className="container">
            <div className="row">
                <div className="col-lg-12">
                    {/* Post Featured Image Start */}
                    <div className="post-image">
                        <figure className="image-anime reveal">
                            <img src={`https://drpatangecitydentalclinic.com/uploads/${news.image}`} alt={news.name} />
                        </figure>
                    </div>
                    {/* Post Featured Image Start */}

                    {/* Post Single Content Start */}
                    <div className="post-content">
                        {/* Post Entry Start */}
                        <div className="post-entry">
                            <p className="wow fadeInUp">{news.details}</p>
                            
                            <blockquote className="wow fadeInUp" data-wow-delay="0.4s">
                                <p>Your oral health is more important than you might realize. It's not just about having a bright smile, it's about maintaining your overall well-being. Regular dental check-ups, proper brushing and flossing, and a healthy diet can prevent many dental issues.</p>
                            </blockquote>


                            <h2 className="text-anime-style-3">Regular Dental Check-ups</h2>

                            <p className="wow fadeInUp" data-wow-delay="0.8s">A balanced diet is crucial for oral health. Limit sugary foods and beverages, as they contribute to tooth decay. Instead, opt for foods rich in calcium and phosphates, such as dairy products, leafy greens, and nuts, which help strengthen tooth enamel. Drink plenty of water to keep your mouth hydrated and to wash away food particles.</p>

                            <ul className="wow fadeInUp" data-wow-delay="1s">
                                <li>Your smile is your best accessory. Keep it shining bright regular dental care.</li>
                                <li>Healthy teeth and gums are the foundation of a beautiful smile and overall well-being.</li>
                                <li>Flossing daily is a small step that makes a big difference in your oral health.</li>
                                <li>Preventive dental care today saves you from major dental problems tomorrow.</li>
                                <li>Your mouth is a window into your overall health. Take care of it with regular check-ups.</li>
                            </ul>

                            <p className="wow fadeInUp" data-wow-delay="1.2s">Incorporating an antimicrobial mouthwash into your daily routine can help reduce plaque, prevent gum disease, and freshen your breath. Look for mouthwashes with fluoride to help strengthen your teeth. However, mouthwash should not replace brushing and flossing but rather complement your oral hygiene regimen.</p>
                        </div>
                        {/* Post Entry End */}

                        {/* Post Tag Links Start */}
                        <div className="post-tag-links">
                            <div className="row align-items-center">
                                <div className="col-lg-8">
                                    {/* Post Tags Start */}
                                    <div className="post-tags wow fadeInUp" data-wow-delay="0.5s">
                                        <span className="tag-links">
                                            Tags:
                                            <a href="#">dentalhealth</a>
                                            <a href="#">teethcare</a>
                                            <a href="#">oralcare</a>
                                            <a href="#">toothache</a>
                                        </span>
                                    </div>
                                    {/* Post Tags End */}
                                </div>

                                <div className="col-lg-4">
                                    {/* Post Social Links Start */}
                                    <div className="post-social-sharing wow fadeInUp" data-wow-delay="0.5s">
                                        <ul>
                                            <li><a href="#"><i className="fa-brands fa-facebook-f"></i></a></li>
                                            <li><a href="#"><i className="fa-brands fa-youtube"></i></a></li>
                                            <li><a href="#"><i className="fa-brands fa-instagram"></i></a></li>
                                            <li><a href="#"><i className="fa-brands fa-x-twitter"></i></a></li>
                                        </ul>
                                    </div>
                                    {/* Post Social Links End */}
                                </div>
                            </div>
                        </div>
                        {/* Post Tag Links End */}
                    </div>
                    {/* Post Single Content End */}
                </div>
            </div>
        </div>
    </div>
    {/* Page Single Post End */} 
        </Master>
    );
}

export default Newsdetail;